module.exports = __webpack_public_path__ + "static/media/dice-one.dd989e86.svg";